import React from 'react';

export default class ErrorLabel extends React.PureComponent {
    render() {
        return (
            <div
                className={`component-Elements-ErrorLabel ${this.props.cssClass}`}
            >
                <style jsx>
                    {`
                        .component-Elements-ErrorLabel {
                            font-size: 12px;
                            font-weight: bold;
                            font-style: italic;
                            color: #ff4578;
                            margin-top: -4px;
                            height: 20px;
                        }
                    `}
                </style>
                {this.props.error}
            </div>
        );
    }
}
